import { api } from "@/lib/axios";
import type { ApiResponse } from "@/features/company/types/company.types";
import type {
  AdminAccountSearchResult,
  MoveAccountCompanyRequest,
  SetInternalDevRequest,
} from "../types/account.types";

export const searchAdminAccounts = async (
  id: string,
): Promise<AdminAccountSearchResult> => {
  const { data } = await api.get<ApiResponse<AdminAccountSearchResult>>(
    "/api/Account/Admin/Search",
    { params: { id } },
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

/** 소속 업체 변경. 성공 메시지에 해제된 역할 수가 담겨 온다 */
export const moveAccountCompany = async (
  params: MoveAccountCompanyRequest,
): Promise<string> => {
  const { data } = await api.post<ApiResponse<null>>(
    "/api/Account/Admin/Move-Company",
    params,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.message;
};

export const setInternalDev = async (
  params: SetInternalDevRequest,
): Promise<string> => {
  const { data } = await api.post<ApiResponse<null>>(
    "/api/Account/Admin/Internal-Dev",
    params,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.message;
};
